module.exports = __webpack_public_path__ + "static/media/icon-close.63363e92.svg";